import { jsx as _jsx } from "react/jsx-runtime";
import { DefaultLinkSimple, LinkSimple } from "../../../link/src";
export const AddOptionalLink = ({ children, href, isExternalLink, }) => {
    if (!href) {
        return children;
    }
    return isExternalLink ? (_jsx(DefaultLinkSimple, { "aria-hidden": "true", "data-testid": "default-link", href: href, tabIndex: -1, target: "_blank", children: children })) : (_jsx(LinkSimple, { "aria-hidden": "true", tabIndex: -1, to: href, children: children }));
};
//# sourceMappingURL=AddOptionalLink.js.map